export default "__VITE_ASSET__C6r8piO4__"